import { LocationDto } from "src/dtos/location/locationDto";
import { WmsStockLotDto } from "src/dtos/wmsLot/wmsStockLotDto";

export interface WMS2020_R01Dto extends WmsStockLotDto {
	
	modelNo: string;
	oldWarehouseCd: string;
	logicCenter: string;
	oldLogicCenter: string;
	logicCenterNm: string;
	movedLotQty: number;

}

export const defaultWMS2020_R01Dto: WMS2020_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',
	purchaseLotNo: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	transportNo: '',
	itemNo: '',
	remark: '',
	
	modelNo: '',
	oldWarehouseCd: '',
	logicCenter: '',
	oldLogicCenter: '',
	logicCenterNm: '',
	movedLotQty: 0,
	
	inserted: false,
	isModified: false,
}